import React, { useEffect, useState,useMemo } from 'react';
import { fetchJson } from '@utils/fetchJson';
import { ChevronDown, ChevronUp,X, Mail,Edit3, Phone, FileText,Zap, Edit, Plus,MessageCircle, PhoneCall, Calendar } from 'lucide-react';
import CommentsHistory from '@plugin/task/views/CommentsHistory';
import { API_BASE_URL } from '../../../config';
import * as Tooltip from '@radix-ui/react-tooltip';
import { useTaskCreateStore } from '@plugin/task/store/useTaskCreateStore';
import clsx from 'clsx'; // if not already, install with: npm install clsx
import { useLeadSidebarStore } from '../store/useLeadSidebarStore';
import { useNotesStore } from '@components/notes/store/useNotesStore';
import { useLeadCreateStore } from '../store/useLeadCreateStore';
export default function LeadSidebar() {
  
  const { isOpen, payload: payloadWrapper, close } = useLeadSidebarStore();
  const [leadData, setLeadData] = useState(null);
    const payload = useMemo(
    () => payloadWrapper?.payload || payloadWrapper || {},
    [payloadWrapper]
    );
      const { openLeadCreate } = useLeadCreateStore();
  const [activeTab, setActiveTab] = useState('comments');
  const [showAdditional, setShowAdditional] = useState(false);
    const { openTaskCreate } = useTaskCreateStore();
    const { openNotes } = useNotesStore();
    
    const handleCreateTask = (rowData) => {
        const rowDataP = {...{customer_id:payload?.record_id},onSaveCallback:handleRefresh};
        openTaskCreate({payload:rowDataP });
        // You can open a modal, navigate, or call another component here
      };
      const handleRefresh = () => {
        console.log("called back from create");
        //renderListAgain(filterData);
        //fetchTaskList(); // ✅ your task reloading logic
      };
        const handleEdit = (rowData) => {
   openLeadCreate({payload:rowData},(result) => {
    payload?.refreshFilterList?.();
  });

};
  useEffect(() => {
    if (payload?.record_id) {
      fetchJson(`${API_BASE_URL}/customerMaster/${payload?.record_id}?menuId=${payload?.menuId}`).then((res) => {
        if (res.flag === 'S') {
          setLeadData(res.data[0]);
        }
      });
    }
  }, [payload?.record_id, payload?.menuId]);
  if (!isOpen) return null;
  if (!leadData) return <div className="w-[360px] p-4 text-center text-gray-400">Loading...</div>;

  const initials = leadData.name?.split(' ').map(w => w[0]).join('').toUpperCase();
const InfoRow = ({ label, value, onEdit }) => (
  <div className="flex justify-between items-start gap-2">
    <div>
      <div className="text-xs text-gray-500">{label}</div>
      <div className="text-sm font-medium text-gray-800">{value || '—'}</div>
    </div>
    <button
      className="text-blue-500 text-xs hover:text-blue-700 mt-1"
      onClick={onEdit}
      title="Edit"
    >
      <Edit3 size={14} />
    </button>
  </div>
);
const ActionButton = ({ icon: Icon,onClick, label, color = 'gray' }) => (
  <Tooltip.Root delayDuration={100}>
    <Tooltip.Trigger asChild>
      <button
        onClick={onClick} 
        className={clsx(
          'w-9 h-9 flex items-center justify-center rounded-full transition-all duration-150 hover:scale-110',
          {
            'bg-gray-100 text-gray-600 hover:bg-gray-200': color === 'gray',
            'bg-green-100 text-green-600 hover:bg-green-200': color === 'green',
            'bg-blue-100 text-blue-600 hover:bg-blue-200': color === 'blue',
          }
        )}
      >
        <Icon size={16} />
      </button>
    </Tooltip.Trigger>
    <Tooltip.Portal>
      <Tooltip.Content side="top" sideOffset={4} className="bg-black text-white text-xs px-2 py-1 rounded shadow-md">
        {label}
        <Tooltip.Arrow className="fill-black" />
      </Tooltip.Content>
    </Tooltip.Portal>
  </Tooltip.Root>
);

  return (
    <div className="w-[560px] pl-10 fixed top-[56px] right-0 h-[calc(100vh-56px)] flex flex-col z-50">
    <div className="w-full overflow-scroll h-[calc(100vh-56px)] bg-white shadow-xl border-l flex flex-col z-50">
      <button onClick={()=>{close()}}className='absolute -left-[-30px] rounded-full bg-white w-[28px] h-[28px] shadow-lg flex items-center justify-center z-10'><X size={16}></X></button>     
      {/* Header */}<Tooltip.Provider>
      <div className='sticky top-0'>
      <div className="w-full border-l bg-white flex flex-col items-center text-center pt-5 px-4 pb-4">
      {/* Profile */}
      {leadData.customer_image ? (
        <div className="w-20 h-20 rounded-full overflow-hidden relative mb-3">
          <img src={leadData.customer_image} alt="User" className="object-cover w-full h-full" />
          <span className="absolute top-1 right-1 w-3 h-3 bg-green-500 rounded-full border-2 border-white" />
        </div>
      ) : (
        <div className="w-20 h-20 rounded-full bg-gradient-to-tr from-blue-500 to-blue-600 text-white text-xl font-semibold flex items-center justify-center mb-3 relative">
          {initials}
          <span className="absolute top-1 right-1 w-3 h-3 bg-green-500 rounded-full border-2 border-white" />
        </div>
      )}

      {/* Name + Record Type */}
        <h2 className="text-base font-semibold text-gray-900">{leadData.name}</h2>
        <p className="text-xs text-gray-500 capitalize">{leadData.record_type}</p>
        <div className="text-xs text-gray-500">{leadData.leadStage || "No stage"}</div>
      </div>
      {/* Action Bar */}<div className="bg-white">
        <div className="mx-3 px-4 py-1 flex justify-between rounded-full bg-gray-100">
             
            <ActionButton icon={Edit3} onClick={(e) =>{  e.stopPropagation(); handleEdit({record_id:leadData.customer_id},(result) => {
            })}} label="Edit" color="gray" />
            <ActionButton icon={MessageCircle} label="Message" color="gray" />
            <ActionButton icon={PhoneCall} label="Call" color="gray" />
            <ActionButton icon={Zap} label="WhatsApp" color="green" />
            <ActionButton onClick={() => handleCreateTask()}  icon={Calendar} label="Task" color="blue" />
            <ActionButton icon={FileText} onClick={(e) =>{  e.stopPropagation(); openNotes({payload:leadData},(result) => {
  })}}  label="Note" color="gray" />
        </div>
        </div>
</div>
      {/* Lead Info */}
        <div className="space-y-2 spece-x-2 px-4 py-3">
          <InfoRow label="Mobile" value={leadData.mobile_no} />
          <InfoRow label="Email" value={leadData.email} />
          <InfoRow label="Assignee" value={leadData.assigneeName || 'Unassigned'} />
          <InfoRow label="Lead Source" value={leadData.leadSource} />
          <InfoRow label="Priority" value={leadData.leadPriority || 'Normal'} />
          <InfoRow label="Preferred Communication" value={leadData.preferred_communication || 'N/A'} />
        </div>

        {/* Dynamic Fields (Optional) */}
       <div className="px-4 py-3 pt-4 border-t">
  <button
    className="flex items-center justify-between w-full text-xs text-gray-600 font-medium uppercase mb-2 hover:text-black"
    onClick={() => setShowAdditional((prev) => !prev)}
  >
    Additional Info
    {showAdditional ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
  </button>

  {showAdditional && (
    <div className="space-y-2">
      <InfoRow label="Service Looking For" value="Social Media Marketing" />
      <InfoRow label="Budget" value="₹25,000/month" />
      <InfoRow label="Location" value="Pune, Maharashtra" />
    </div>
  )}
   {/* Comments + History */}
      <div className="flex-grow">
        <div className="py-2 border-b">
          <CommentsHistory showWorkLog={false} record_type="lead" recordId={leadData.customer_id} />
        </div>
        <div className="py-2">
          {/* History content will be loaded via CommentsHistory or a separate History component */}
          <HistorySection customerId={leadData.customer_id} />
        </div>
      </div>
</div>
      
     
      </Tooltip.Provider>
    </div>
    </div>
  );
}

function HistorySection({ customerId }) {
  const [history, setHistory] = useState([]);

  useEffect(() => {
    const fetchHistory = async () => {
      const res = await fetchJson(`${API_BASE_URL}/customerMasterList/Activity`, {
        method: 'POST',
        body: JSON.stringify({
          historyType: 'upcoming',
          customer_id: customerId,
        }),
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (res?.flag === 'S') {
        setHistory(res.data);
      }
    };
    fetchHistory();
  }, [customerId]);

  return (
    <div className="text-sm text-gray-600 space-y-2 mt-2">
      <div className="font-semibold text-gray-800">Upcoming Activities</div>
      {history.length === 0 && <div className="text-gray-400 text-xs">No upcoming activities.</div>}
      {history.map((item, i) => (
        <div key={i} className="border rounded p-2 bg-gray-50">
          <div><strong>{item.task_type}</strong> - {item.subject}</div>
          <div className="text-xs text-gray-500">{item.task_date}</div>
        </div>
      ))}
    </div>
  );
}
